
import {
  Directive,
  HostListener,
  Inject,
  DOCUMENT,
} from "@angular/core";

@Directive({
    selector: "[lsLivechatButton]",
    standalone: true,
})
export class LivechatButtonDirective {

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {
    }

    @HostListener("click", ["$event.target"])
    private openLiveChat(): void {
        // @ts-ignore
        if (this.document.defaultView.LiveChatWidget) {
            // @ts-ignore
            const state: LiveChatWidgetState = this.document.defaultView.LiveChatWidget.get("state");
            if (state.visibility === "maximized") {
                // @ts-ignore
                this.document.defaultView.LiveChatWidget.call("minimize");
            }
            if (state.visibility === "hidden") {
                // @ts-ignore
                // this.document.defaultView.LiveChatWidget.call("maximize");
                this.document.defaultView.LiveChatWidget.call("maximize");
            }
        }
    }
}

export interface LiveChatWidgetState {
    availability: LiveChatWidgetStateAvailability;
    visibility: LiveChatWidgetStateVisibility;
}

export type LiveChatWidgetStateAvailability = "online" | "offline";
export type LiveChatWidgetStateVisibility = "maximized" | "minimized" | "hidden";
